import {
  GraphQLSchema, buildClientSchema, IntrospectionQuery, GraphQLObjectType,
} from 'graphql';

export default class GraphQLIntrospection {
  #graphQLSchema: GraphQLSchema;

  constructor(introspection: IntrospectionQuery) {
    this.#graphQLSchema = buildClientSchema(introspection);
  }

  protected get graphQLSchema() {
    return this.#graphQLSchema;
  }

  get mutations() {
    const mutationType = this.#graphQLSchema.getMutationType() as GraphQLObjectType;
    return Object.values(mutationType.getFields());
  }

  get queries() {
    const queryType = this.#graphQLSchema.getQueryType() as GraphQLObjectType;
    return Object.values(queryType.getFields());
  }
}
